import axios, { all } from "axios";
import AddCategory from "Components/Admin-Components/Category/AddCategory";
import EditCategory from "Components/Admin-Components/Category/EditCategory";
import ConfirmDeleteModal from "Components/Admin-Components/Common Modals/ConfirmDeleteModal";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaSearch } from "react-icons/fa";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import { MdOutlineCategory, MdOutlineDeleteOutline } from "react-icons/md";
import { TiEdit } from "react-icons/ti";

function Category() {
  const [loading, setLoading] = useState(false); //State for loader

  //States for opening different modals
  const [createCategoryModalOpen, setCreateCategoryModalOpen] = useState(false);
  const [editCategoryModalOpen, setEditCategoryModalOpen] = useState(false);
  const [deleteModalOpen, setdeleteModalOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState(""); //State for storing search term
  const [allCategories, setAllCategories] = useState([]); //State for storing all categories
  const [selectedCategory, setSelectedCategory] = useState({}); //State for storing a selected category
  const [filteredCategories, setFilteredCategories] = useState([]);

  //State for pagination
  const [currentPage, setCurrentPage] = useState(1);

  //Fetching user details from the local storage
  const storedData = localStorage.getItem("Ananya Enterprize-Users-Data");

  //Converting the fetched user details into JSON
  const userData = storedData ? JSON.parse(storedData) : {};

  //Function to get all the categories
  const getAllCategories = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/category/get-all-categories`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllCategories: ", response.data);
        setAllCategories(response.data.categories);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in fetching all categories: ", error);
        setLoading(false);
      });
  };

  //Function to delete a site
  const deleteCategory = (categoryId) => {
    setLoading(true);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/category/delete-category/${categoryId}`,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of deleteCategory: ", response.data);
        setLoading(false);
        setdeleteModalOpen(false);
        getAllCategories();
        toast.success(response.data.message);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        toast.error("Error in deleting category");
      });
  };

  //Function to handle action button click
  const handleActionButtonClick = (clickType, site) => {
    setSelectedCategory(site);
    if (clickType === "Edit") {
      setEditCategoryModalOpen(true);
    } else if (clickType === "Delete") {
      setdeleteModalOpen(true);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  useEffect(() => {
    const filteredCategories = allCategories?.filter((category) => {
      const matchesSearch = category?.name
        ?.toLowerCase()
        .includes(searchTerm.toLocaleLowerCase());
      return matchesSearch;
    });
    setFilteredCategories(filteredCategories);
  }, [searchTerm, allCategories]);

  //Pagination Logic
  const categoriesPerPage = 10;
  const totalPages = Math.ceil(filteredCategories?.length / categoriesPerPage);

  //Function to handle page change
  const handlePageChange = (newPage) => {
    if (newPage === 0) {
      setCurrentPage(1);
    } else if (newPage > totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(newPage);
    }
  };
  //Finding the catgories for current page
  const currentCategories = filteredCategories.slice(
    (currentPage - 1) * categoriesPerPage,
    currentPage * categoriesPerPage
  );

  return (
    <div className="mx-2 my-6 md:my-8">
      {/* All modals are rendered here  */}

      {/* Create Category Modal  */}
      {createCategoryModalOpen && (
        <AddCategory
          id={userData._id}
          onClose={() => setCreateCategoryModalOpen(false)}
          getAllCategories={getAllCategories}
        />
      )}

      {/* Edit Category Modal  */}
      {editCategoryModalOpen && (
        <EditCategory
          id={userData._id}
          onClose={() => setEditCategoryModalOpen(false)}
          category={selectedCategory}
          getAllCategories={getAllCategories}
        />
      )}

      {/* Delete Confirmation Modal  */}
      {deleteModalOpen && (
        <ConfirmDeleteModal
          item="category"
          deleteFunction={() => deleteCategory(selectedCategory._id)}
          onClose={() => setdeleteModalOpen(false)}
        />
      )}
      <div className="relative flex items-center justify-between ">
        <h1 className="text-3xl font-bold tracking-wide text-primary ">
          Category
        </h1>
        <button
          className="flex h-fit items-center gap-1 rounded bg-primary px-2 py-1 text-sm font-bold tracking-wide text-white hover:bg-hoverPrimary"
          onClick={() => setCreateCategoryModalOpen(true)}
        >
          Create Category <MdOutlineCategory size={14} />
        </button>
      </div>

      <div className="my-6 flex flex-col gap-4">
        <div className="relative flex flex-col justify-between gap-2 md:flex-row md:items-center">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[100%] rounded-lg border border-gray-300 p-2 pl-8 pr-10 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
          />
          <FaSearch className="absolute left-2 top-5 -translate-y-1/2 transform text-primary md:left-2 md:top-1/2" />
        </div>

        {/* Category table goes here  */}
        <div className="min-h-[70vh] overflow-x-auto ">
          <table className="min-w-full overflow-y-visible rounded-md border-blue-200 ">
            {/* Table Head  */}
            <thead>
              <tr className="bg-blue-50">
                <th className="rounded-tl-xl px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Sl
                </th>

                <th className="rounded-tl-xl px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Category Name
                </th>

                <th className="rounded-tl-xl px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Description
                </th>

                <th className="rounded-tl-xl px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Actions
                </th>
              </tr>
            </thead>

            {/* Table Body  */}
            <tbody className="text-[13px] font-medium tracking-wide text-[#202224]">
              {loading ? (
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="animate-pulse border-b border-gray-200"
                  >
                    <td className="px-6 py-4">
                      <div className="h-4  w-1/3 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-3/4 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-full rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-1/2 rounded bg-skeletonLoaderColor"></div>
                    </td>
                  </tr>
                ))
              ) : currentCategories.length > 0 ? (
                currentCategories.map((category, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {index + 1}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {category.name}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {category.categoryDescription}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      <div className="flex items-center gap-2">
                        {/* Edit Category Button  */}
                        <button>
                          <TiEdit
                            size={24}
                            title="Edit Category"
                            className="cursor-pointer font-bold text-green-500 duration-300 hover:scale-105 hover:text-green-800"
                            onClick={() =>
                              handleActionButtonClick("Edit", category)
                            }
                          />
                        </button>

                        {/* Delete Category Button */}
                        <button>
                          <MdOutlineDeleteOutline
                            size={24}
                            title="Delete Category"
                            className="cursor-pointer font-bold text-red-500 duration-300 hover:scale-105 hover:text-red-800"
                            onClick={() =>
                              handleActionButtonClick("Delete", category)
                            }
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={4}
                    className="px-6 py-40 text-center text-lg text-gray-600"
                  >
                    No Categories available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="float-right my-4 flex items-center justify-end gap-2 font-medium">
          <span className="text-sm text-primaryText">
            {currentPage} - {totalPages} pages
          </span>
          <div className="flex  items-center gap-2">
            <button
              className={`cursor-pointer rounded font-bold  ${
                currentPage === 1
                  ? "text-gray-300 hover:text-gray-300"
                  : "text-primary hover:text-hoverPrimary"
              }`}
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              <IoIosArrowDropleft size={24} />
            </button>

            <button
              className={`cursor-pointer rounded font-bold  ${
                currentPage === totalPages
                  ? "text-gray-300 hover:text-gray-300"
                  : "text-primary hover:text-hoverPrimary"
              }`}
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              <IoIosArrowDropright size={24} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Category;
